import { Action } from '@ngrx/store';
import {BatteryTestSchedulerModel, BatteryTestSchedulerDetailModel, BatteryTestSchedulerResultModel} from '../battery-test.model';

export enum BatteryTestSchedulerActionTypes {
  LoadBatteryTestScheduler = '[BatteryTestScheduler] Load BatteryTestScheduler',
  LoadBatteryTestSchedulerSuccess = '[BatteryTestScheduler] Load BatteryTestScheduler Success',
  LoadBatteryTestSchedulerFail = '[BatteryTestScheduler] Load BatteryTestScheduler Fail',
  LoadBatteryTestSchedulerDetail = '[BatteryTestScheduler] Load BatteryTestSchedulerDetail',
  LoadBatteryTestSchedulerDetailSuccess = '[BatteryTestScheduler] Load BatteryTestSchedulerDetail Success',
  LoadBatteryTestSchedulerDetailFail = '[BatteryTestScheduler] Load BatteryTestSchedulerDetail Fail',
  AddBatteryTestScheduler = '[BatteryTestScheduler] Add BatteryTestScheduler',
  // AddBatteryTestSchedulerSuccess = '[BatteryTestScheduler] Add BatteryTestScheduler Success',
  AddBatteryTestSchedulerFail = '[BatteryTestScheduler] Add BatteryTestScheduler Fail',
  UpdateBatteryTestScheduler = '[BatteryTestScheduler] Update BatteryTestScheduler',
  // UpdateBatteryTestSchedulerSuccess = '[BatteryTestScheduler] Update BatteryTestScheduler Success',
  UpdateBatteryTestSchedulerFail = '[BatteryTestScheduler] Update BatteryTestScheduler Fail',
  DeleteBatteryTestScheduler = '[BatteryTestScheduler] Delete BatteryTestScheduler',
  // DeleteBatteryTestSchedulerSuccess = '[BatteryTestScheduler] Delete BatteryTestScheduler Success',
  DeleteBatteryTestSchedulerFail = '[BatteryTestScheduler] Delete BatteryTestScheduler Fail',
  LoadBatteryTestSchedulerResult = '[BatteryTestScheduler] Load BatteryTestScheduler Result',
  LoadBatteryTestSchedulerResultSuccess = '[BatteryTestScheduler] Load BatteryTestScheduler Result Success',
  LoadBatteryTestSchedulerResultFail = '[BatteryTestScheduler] Load BatteryTestScheduler Result Fail',
  ExecBatteryTestScheduler = '[BatteryTestScheduler] Exec BatteryTestScheduler',
  // ExecBatteryTestSchedulerSuccess = '[BatteryTestScheduler] Exec BatteryTestScheduler Success',
  ExecBatteryTestSchedulerFail = '[BatteryTestScheduler] Exec BatteryTestScheduler Fail',

}

export class LoadBatteryTestScheduler implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestScheduler;
  constructor(public payload: any = null) {}
}

export class LoadBatteryTestSchedulerSuccess implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerSuccess;
  constructor(public payload: BatteryTestSchedulerModel[]) {}
}

export class LoadBatteryTestSchedulerFail implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerFail;
}

export class LoadBatteryTestSchedulerDetail implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerDetail;
  constructor(public payload: any = null) {}
}

export class LoadBatteryTestSchedulerDetailSuccess implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerDetailSuccess;
  constructor(public payload: BatteryTestSchedulerDetailModel) {}
}

export class LoadBatteryTestSchedulerDetailFail implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerDetailFail;
}

export class AddBatteryTestScheduler implements Action {
  readonly type = BatteryTestSchedulerActionTypes.AddBatteryTestScheduler;
  constructor(public payload: any = null) {}
}

// export class AddBatteryTestSchedulerSuccess implements Action {
//   readonly type = BatteryTestSchedulerActionTypes.AddBatteryTestSchedulerSuccess;
//   constructor(public payload: BatteryTestSchedulerModel[]) {}
// }

export class AddBatteryTestSchedulerFail implements Action {
  readonly type = BatteryTestSchedulerActionTypes.AddBatteryTestSchedulerFail;
}

export class UpdateBatteryTestScheduler implements Action {
  readonly type = BatteryTestSchedulerActionTypes.UpdateBatteryTestScheduler;
  constructor(public payload: any = null) {}
}

// export class UpdateBatteryTestSchedulerSuccess implements Action {
//   readonly type = BatteryTestSchedulerActionTypes.UpdateBatteryTestSchedulerSuccess;
//   constructor(public payload: BatteryTestSchedulerModel[]) {}
// }

export class UpdateBatteryTestSchedulerFail implements Action {
  readonly type = BatteryTestSchedulerActionTypes.UpdateBatteryTestSchedulerFail;
}

export class DeleteBatteryTestScheduler implements Action {
  readonly type = BatteryTestSchedulerActionTypes.DeleteBatteryTestScheduler;
  constructor(public payload: any = null) {}
}

// export class DeleteBatteryTestSchedulerSuccess implements Action {
//   readonly type = BatteryTestSchedulerActionTypes.DeleteBatteryTestSchedulerSuccess;
//   constructor(public payload: BatteryTestSchedulerModel[]) {}
// }

export class DeleteBatteryTestSchedulerFail implements Action {
  readonly type = BatteryTestSchedulerActionTypes.DeleteBatteryTestSchedulerFail;
}

export class LoadBatteryTestSchedulerResult implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerResult;
  constructor(public payload: any = null) {}
}

export class LoadBatteryTestSchedulerResultSuccess implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerResultSuccess;
  constructor(public payload: BatteryTestSchedulerResultModel[]) {}
}

export class LoadBatteryTestSchedulerResultFail implements Action {
  readonly type = BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerResultFail;
}

export class ExecBatteryTestScheduler implements Action {
  readonly type = BatteryTestSchedulerActionTypes.ExecBatteryTestScheduler;
  constructor(public payload: any = null) {}
}

// export class ExecBatteryTestSchedulerSuccess implements Action {
//   readonly type = BatteryTestSchedulerActionTypesExecBatteryTestSchedulerSuccess;
//   constructor(public payload: BatteryTestSchedulerModel[]) {}
// }

export class ExecBatteryTestSchedulerFail implements Action {
  readonly type = BatteryTestSchedulerActionTypes.ExecBatteryTestSchedulerFail;
}

export type BatteryTestSchedulerActions = LoadBatteryTestScheduler
  | LoadBatteryTestSchedulerSuccess
  | LoadBatteryTestSchedulerFail
  | LoadBatteryTestSchedulerDetail
  | LoadBatteryTestSchedulerDetailSuccess
  | LoadBatteryTestSchedulerDetailFail
  | AddBatteryTestScheduler
  // | AddBatteryTestSchedulerSuccess
  | AddBatteryTestSchedulerFail
  | UpdateBatteryTestScheduler
  // | UpdateBatteryTestSchedulerSuccess
  | UpdateBatteryTestSchedulerFail
  | DeleteBatteryTestScheduler
  // | DeleteBatteryTestSchedulerSuccess
  | DeleteBatteryTestSchedulerFail
  | LoadBatteryTestSchedulerResult
  | LoadBatteryTestSchedulerResultSuccess
  | LoadBatteryTestSchedulerResultFail
  | ExecBatteryTestScheduler
  // | ExecBatteryTestSchedulerSuccess
  | ExecBatteryTestSchedulerFail;
